export const genders = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' }
]